export default __webpack_public_path__ + "static/media/brazil.87a5bcd4.svg";